import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class MyToast extends React.Component {
  render() {
    return (
      <ToastContainer
        position="bottom-left"
        autoClose={3200}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        icon={false}
        draggable
        pauseOnHover
      />
    );
  }
}

export default MyToast;
